import { render, staticRenderFns } from "./FinanceApproverHtmlTemplate.vue?vue&type=template&id=36fc0eff&scoped=true"
import script from "./FinanceApproverHtmlTemplate.vue?vue&type=script&lang=js"
export * from "./FinanceApproverHtmlTemplate.vue?vue&type=script&lang=js"
import style0 from "./FinanceApproverHtmlTemplate.vue?vue&type=style&index=0&id=36fc0eff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc0eff",
  null
  
)

export default component.exports